module.exports = __webpack_public_path__ + "img/imgOrigin.3cb4593a.png";